import { Channel, I18N } from '../constants';
import { logger } from '@monofront/logging';

export const getChannelFromLocale = (locale: string | undefined): Channel => {
  if (!locale || !I18N[locale]) {
    logger.error(`Channel ${locale} not found`);

    return I18N['fr'].channel;
  }

  return I18N[locale].channel;
};
